<template>
    <div class="checklist-template-index">
        <transition mode="out-in">
            <div class="mt-4 grid grid-cols-8 grid-flow-row gap-4">
                <div class="col-span-8 p-4 relative border-2 rounded-lg">
                        <p class="inline-block text-gray-600 text-base font-bold mr-2">WirelessSupportSync Settings</p>
                        <el-form label-position="top" size="small">
                            <div class="col-span-12 mt-2 md:col-span-6 lg:col-span-4">
                                <div v-if="!featurePermissions['featureEnabledWirelessSupportSync']">
                                    <h1>Upgrade Required</h1>
                                    <p>
                                        To enable Wireless Support Sync features, you'll need to upgrade your plan. Please contact Hera
                                        Support by chatting with us below.
                                    </p>
                                </div>
                                <div v-else>
                                    <div>Enable Wireless Support Sync for {{ userInfo.tenant.companyName }}</div>
                                    <el-switch
                                        :class="{'switch-loading': permissionWirelessSupportSync.loading}"
                                        v-model="permissionWirelessSupportSync.value"
                                        active-color="#13ce66"
                                        :disabled="disabledPermissionWirelessSupportSync"
                                        @change="toggleWirelessSupportSyncFeature">
                                    </el-switch>
                                    <div class="mt-4">
                                        <el-button
                                            type="primary"
                                            size="small"
                                            :disabled="disabledRemoveMiradoreButton"
                                            @click="confirmRemoveMiradoreApiKey">
                                            Remove Miradore API Key
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { getTenantFeaturePermissions } from '@/middlewares/permissions';
import { updateTenantDetail } from '@/store/mutations';
import { mapGetters, mapState } from 'vuex';

export default{
    name: "WirelessSupportSyncSettings",
    data(){
        return {
            permissionWirelessSupportSync: {
                loading :false,
                value:false
            }
        }
    },
    beforeMount() {
        this.permissionWirelessSupportSync.value = this.userInfo?.tenant?.permissionWirelessSupportSync;
    },
    computed: {
        ...mapState(['userInfo']),
        ...mapGetters(['isSystemAdmin']),
        disabledPermissionWirelessSupportSync(){
            if(!this.featurePermissions.featureEnabledWirelessSupportSync){
                return true
            }
            if(this.userInfo.permissionFullAccess || this.isSystemAdmin){
                return false
            }
            return true
        },
        disabledRemoveMiradoreButton(){
            return this.disabledPermissionWirelessSupportSync || !this.userInfo.tenant.miradoreApiKey
        },
        featurePermissions(){
            return getTenantFeaturePermissions()
        }
    },
    methods: {
        async toggleWirelessSupportSyncFeature(value){
            this.permissionWirelessSupportSync.loading = true
            try {
                const updated = await this.updatePermissionWirelessSupportSync(value)
                this.permissionWirelessSupportSync.value = updated.permissionWirelessSupportSync
            } catch (error) {
                this.displayUserError(error)
                this.permissionWirelessSupportSync.value = !value
            }
            this.permissionWirelessSupportSync.loading = false
        },
        async updatePermissionWirelessSupportSync(value){
            const input = {
                id: this.userInfo.tenant.id,
                permissionWirelessSupportSync: value
            }
            const response = await this.api(updateTenantDetail, { input })
            return response.data.updateTenant
        },
        confirmRemoveMiradoreApiKey(){
            this.$confirm('If you remove the Miradore API key, your Wireless Support syncing will be turned off.', 'Warning', {
                confirmButtonText: 'Remove',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.removeMiradoreApiKey()
            }).catch(() => {})
        },
        async removeMiradoreApiKey(){
            try {
                const input = {
                    id: this.userInfo.tenant.id,
                    miradoreApiKey: '',
                }
                const response = await this.api(updateTenantDetail, { input })
                this.$store.commit('setTenant', response.data.updateTenant)
                this.$message.success('Miradore API key removed successfully')
            } catch (error) {
                this.displayUserError(error)
            }
        }
    }
}
</script>
<style lang="scss">
.checklist-template-index{
    .switch-loading{
        .el-switch__core::after {
            content: "";
            position: absolute;
            border: 2px solid theme('colors.blue.500');
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
    }
}
@keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
}
</style>